/**
 * Resources Menu are used by application
 * navigate resources in the header
 */
export enum ResourcesMenu {
  CERTIFICATIONS = 'Certifications',
  LEARNING_PATHS = 'Learning Paths',
  RESOURCES = 'Resources',
  GETTING_STARTED = 'Getting Started',
  TERMS_AND_CONDITION = 'Terms and Conditions',
  VOUCHER_REDEMPTION = 'Redeem Voucher',
  VIDEOS = 'Videos',
}
